import React from 'react';
import PropTypes from 'prop-types';

/**
 * SelectDisplayFormat
 */
class SelectDisplayFormat extends React.Component {
  constructor(props) {
    super(props);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.state = {
      isModalOpen: false,
    };
  }

  componentDidUpdate() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (this.state.isModalOpen) {
      const selectDisplayFormatChildView = document.getElementById('select_display_format_child');
      selectDisplayFormatChildView.style.top = $('#select_display_format_parent').offset().top + 'px';

      // 表示形式のコンテンツ位置を取得
      let targetModalElement = $('#switchDisplayFormat');
      let targetModalElementOffset = targetModalElement.offset();
      // ヘルプ画像の情報取得
      let selfContent = $('#modal_help_content');
      // // topを算出
      let targetTop = targetModalElementOffset.top - (selfContent.height() / 2) - (targetModalElement.height() / 2) + 5;
      // // leftを算出
      let targetLeft = (targetModalElementOffset.left - selfContent.width()) - 62;

      // $('#modal_help_content').css({ top: targetTop, left: targetLeft });
      $('#modal_help_content').css({ top: '25%', left: 0 });
    }
  }

  handleOptionChange(event) {
    this.setState({ selectedOption: event.target.value });
    this.props.actions.changeDisplayFormat(event.target.value);
  }

  openModal() {
    this.setState({ isModalOpen: true });
    $('#modal_help_content').show();
  }

  closeModal() {
    this.setState({ isModalOpen: false });
    $('#modal_help_content').hide();
  }

  render() {
    const defaultValue = this.props.data.displayFormat;
    const isReadOnly = this.props.isReadOnly;
    const disabledLabelClass = isReadOnly ? 'disabled_label' : '';
    const { isModalOpen } = this.state;

    return (
      <div id="select_display_format_parent">
        <div id="select_display_format_child">
          <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable controlForm__text--state_enable">
            <div className="select_display_format_title" onClick={this.openModal}>
              <p>表示形式</p>
              <span className="select_display_format_title_help_img" />
            </div>
          </div>
          <div id="switchDisplayFormat" className="switchDisplayFormat">
            <input type="radio" name="displayFormat" id="dow" value="dow" checked={defaultValue == 'dow'} onChange={this.handleOptionChange} readOnly={isReadOnly} />
            <label htmlFor="dow" className={`${disabledLabelClass} ${defaultValue == 'dow' ? 'switch-on' : 'switch-off'}`}>曜日表示</label>
            <input type="radio" name="displayFormat" id="progress" value="progress" checked={defaultValue == 'progress'} onChange={this.handleOptionChange} readOnly={isReadOnly} />
            <label htmlFor="progress" className={`${disabledLabelClass} ${defaultValue == 'progress' ? 'switch-on' : 'switch-off'}`}>経過日数表示</label>
          </div>

          {isModalOpen && (
            <div className="modal_overlay" onClick={this.closeModal}>
              <div id="modal_help_content" className="modal_help_content" onClick={e => e.stopPropagation()}>
                <img className="help_image_k012" src="../../img/help_image_k012.png" alt="ヘルプ画像" />
                <button onClick={this.closeModal} className="modal_close_button">OK</button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

SelectDisplayFormat.propTypes = {
  actions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
};

export default SelectDisplayFormat;
